import MasterCrudPage from "../../components/MasterCrudPage";
import { socialMediaMasterApi } from "../../api/masterApi";

export default function SocialMediaMaster() {
  return (
    <MasterCrudPage
      title="Social Media Master"
      description="Platforms such as Website, Instagram, Facebook, YouTube, Twitter/X, LinkedIn."
      idKey="social_media_id"
      api={socialMediaMasterApi}
      listLabel="social media platforms"
      useJson
      fields={[
        {
          name: "social_media_platform",
          label: "Social Media Platform",
          type: "text",
          required: true,
          fullWidth: true,
          placeholder: "e.g. Instagram, Facebook, YouTube",
        },
      ]}
      columns={[
        { key: "social_media_id", label: "Social Media" },
        { key: "social_media_platform", label: "Platform" },
      ]}
    />
  );
}
